import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { AgentChatLogo } from '@/components/agent-chat-logo';

import './prop-chat-thinking-indicator.css';

/**
 * The waiting state for an agent answer: the animated agent mark next to a
 * shimmering "Agent is thinking..." label.
 *
 * Readable when browsing, but deliberately not a live region - ChatMessages
 * owns the announcements, so the wait is not read out twice.
 */
export const PropChatThinkingIndicator: FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex w-full items-center gap-[var(--ds-space-2)]">
      <AgentChatLogo spinning className="size-[var(--ds-space-6)]" />
      <span className="prop-chat-thinking-text min-w-0 font-[var(--ds-typography-font-definitions-font-family-body)] text-[length:var(--ds-typography-paragraph-13-regular-font-size)] font-[var(--ds-typography-paragraph-paragraph-medium-weight)] leading-[var(--ds-typography-paragraph-mini-line-height)] tracking-[var(--ds-typography-paragraph-mini-letter-spacing)]">
        {t('prop-chat.agent-thinking')}
      </span>
    </div>
  );
};
